'use client'

import { useEffect } from 'react'

import { getClientEnv } from '@/env/client'
import { Link } from '@/i18n/navigation'

export default function ErrorPage({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        const { logger } = getClientEnv()
        logger
            .withError(error)
            .withMetadata({ digest: error.digest, boundary: 'locale' })
            .error('Unhandled page error')
    }, [error])

    return (
        <div className="container flex max-w-sm flex-col items-center py-15 text-center">
            <h1 className="pb-4 text-xl font-bold">Unable to load this page</h1>
            <p className="pb-6">
                Something went wrong while loading this route. You can try again or head back to our{' '}
                <Link className="text-[#087484] underline" href="/">
                    homepage
                </Link>
                .
            </p>
            <button
                onClick={reset}
                className="rounded-md bg-[#087484] px-6 py-2 text-sm font-medium text-white hover:bg-[#065e6a]"
            >
                Try again
            </button>
        </div>
    )
}
